import script from "./AdminPaperImport.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminPaperImport.vue?vue&type=script&setup=true&lang=js"

import "./AdminPaperImport.vue?vue&type=style&index=0&id=31219e8d&scoped=true&lang=css"

import exportComponent from "/Users/lidonglei/Documents/project/MathQuestionBank/quesbank_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-31219e8d"]])

export default __exports__